import { render, staticRenderFns } from "./EditTag.vue?vue&type=template&id=1366d206&scoped=true&"
import script from "./EditTag.vue?vue&type=script&lang=js&"
export * from "./EditTag.vue?vue&type=script&lang=js&"
import style0 from "./EditTag.vue?vue&type=style&index=0&id=1366d206&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1366d206",
  null
  
)

export default component.exports